import base from "notifications/notifications";
Vue.component("spark-notifications", {
    mixins: [base],
});
